module.exports = __webpack_public_path__ + "img/14.79f4cd4d.jpg";